import { render, staticRenderFns } from "./CollectionCreatorSourceOptions.vue?vue&type=template&id=37362751"
import script from "./CollectionCreatorSourceOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCreatorSourceOptions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports